import { useContext, useMemo } from "react";
import AddPageSubMenu from "src/components/layouts/AddPageSubMenu";
import GroupIdentityContext from "src/contexts/data/GroupIdentityContext";
import { createGroupSubMenu } from "src/routing/navigation";

const GroupSubMenu: React.FC = () => {
    const { data: groupIdentity } = useContext(GroupIdentityContext);

    const subMenu = useMemo(() => {
        if (!groupIdentity) {
            return null;
        }

        return createGroupSubMenu(groupIdentity);
    }, [groupIdentity]);

    if (!subMenu) {
        return null;
    }

    return <AddPageSubMenu subMenu={subMenu} />;
};

export default GroupSubMenu;
